import React from "react";
import { AlertTriangle, MapPin, LifeBuoy, Share2, FileSearch } from "lucide-react";
import { ICON_STROKE } from "../../ui/icon";

const PublicQuickActionsBar = ({
  t,
  onReport,
  onNearby,
  onFirstAid,
  onShareLocation,
  showResumeReport,
  onResumeReport,
}) => {
  const actions = [
    { key: "report", icon: AlertTriangle, label: t("public.quickReport"), onClick: onReport, danger: true },
    { key: "firstaid", icon: LifeBuoy, label: t("public.quickFirstAid"), onClick: onFirstAid },
    { key: "nearby", icon: MapPin, label: t("public.quickNearby"), onClick: onNearby },
    { key: "share", icon: Share2, label: t("public.quickShare"), onClick: onShareLocation },
  ];

  if (showResumeReport) {
    actions.push({ key: "resume", icon: FileSearch, label: t("public.quickFindReport"), onClick: onResumeReport });
  }

  return (
    <nav className="pub-quickbar" aria-label={t("public.quickActions")}>
      {actions.map(({ key, icon: Icon, label, onClick, danger }) => (
        <button
          key={key}
          type="button"
          className={`pub-quickbar__btn${danger ? " pub-quickbar__btn--danger" : ""}`}
          onClick={onClick}
        >
          <Icon size={20} strokeWidth={ICON_STROKE} aria-hidden />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
};

export default PublicQuickActionsBar;
